import { render, staticRenderFns } from "./SupportCaseForm.vue?vue&type=template&id=cd7a408a"
import script from "./SupportCaseForm.vue?vue&type=script&lang=js"
export * from "./SupportCaseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports